import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

/* Design System — must load first */
import '@/styles/tokens/design-system.css'

/* Render Lock — layout stability */
import '@/styles/tokens/render-lock.css'

/* Visual Layer System */
import '@/styles/tokens/layers.css'

/* Micro UI Ecosystem */
import '@/styles/tokens/micro-ecosystem.css'

/* Pixel Deterministic Engine — final rendering consistency */
import '@/styles/tokens/pixel-deterministic.css'

/* Swiper */
import 'swiper/swiper-bundle.css'

/* Snapshot runtime */
import '@/snapshot/js/flexible'
import '@/snapshot/js/runtime'
import '@/snapshot/js/loaded'

/* Global Styles */
import '@/snapshot/css/reset.css'
import '@/snapshot/css/vendors.css'
import '@/snapshot/css/app.css'
import '@/snapshot/css/animation.css'

/* Fonts */
import '@/assets/fonts/fonts.css'

Vue.config.productionTip = false

new Vue({ router, store, render: h => h(App) }).$mount('#app')
